var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.954,
    height: 17.172,
    viewBox: "0 0 15.954 17.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "city") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#768092;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.546)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.546)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.941,56.208v-.885H74.267v.885h-.426v6.787h3.883V56.208Zm-1.313,5.51H74.19V60.709h.438Zm0-1.379H74.19V59.329h.438Zm0-1.38H74.19V57.95h.438Zm0-1.38H74.19V56.571h.438Zm.687,4.138h-.439V60.709h.439Zm0-1.379h-.439V59.329h.439Zm0-1.38h-.439V57.95h.439Zm0-1.38h-.439V56.571h.439ZM76,61.717h-.439V60.709H76Zm0-1.379h-.439V59.329H76Zm0-1.38h-.439V57.95H76Zm0-1.38h-.439V56.571H76Zm.687,4.138H76.25V60.709h.439Zm0-1.379H76.25V59.329h.439Zm0-1.38H76.25V57.95h.439Zm0-1.38H76.25V56.571h.439Zm.687,4.138h-.439V60.709h.439Zm0-1.379h-.439V59.329h.439Zm0-1.38h-.439V57.95h.439Zm0-1.38h-.439V56.571h.439Z",
    transform: "translate(-61.77 -45.823)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M49.743,15.761v-1.65h-.412V5.139h-.318V4.181h-.375V3.568h-.313l-.232-1.731h0V1.657h-.172L47.9,0h-.04l-.021,1.657h-.172v.181l-.232,1.731h-.312v.612h-.375v.958H46.43v8.972h-.412v1.65h-.307v1.411H50.05V15.761Z",
    transform: "translate(-38.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M26.724,35.708v11.04h2.768V35.708Zm.679,9.5h-.377V44.37H27.4Zm0-1.2h-.377v-.839H27.4Zm0-1.2h-.377v-.839H27.4Zm0-1.2h-.377v-.839H27.4Zm0-1.2h-.377v-.839H27.4Zm0-1.2h-.377v-.839H27.4Zm0-1.2h-.377v-.839H27.4Zm0-1.2h-.377V35.99H27.4Zm.6,8.38h-.376V44.37H28Zm0-1.2h-.376v-.839H28Zm0-1.2h-.376v-.839H28Zm0-1.2h-.376v-.839H28Zm0-1.2h-.376v-.839H28Zm0-1.2h-.376v-.839H28Zm0-1.2h-.376v-.839H28Zm0-1.2h-.376V35.99H28Zm.6,8.38h-.377V44.37h.377Zm0-1.2h-.377v-.839h.377Zm0-1.2h-.377v-.839h.377Zm0-1.2h-.377v-.839h.377Zm0-1.2h-.377v-.839h.377Zm0-1.2h-.377v-.839h.377Zm0-1.2h-.377v-.839h.377Zm0-1.2h-.377V35.99h.377Zm.6,8.38h-.376V44.37h.376Zm0-1.2h-.376v-.839h.376Zm0-1.2h-.376v-.839h.376Zm0-1.2h-.376v-.839h.376Zm0-1.2h-.376v-.839h.376Zm0-1.2h-.376v-.839h.376Zm0-1.2h-.376v-.839h.376Zm0-1.2h-.376V35.99h.376Z",
    transform: "translate(-22.744 -29.576)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M6.554,39.711V37.949H5.039v-.637H3.956v.637h-.41V48.077H7.035V39.711Z",
    transform: "translate(-3.546 -30.905)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.3bea3f4a080638ff35702e184c5108bd.svg";
export { ForwardRef as ReactComponent };